// extracted by mini-css-extract-plugin
export default {"root":"ReasonDropdownSection_root__aRKf4","title":"ReasonDropdownSection_title__-gJtQ"};